import type { FaireBrandEntity } from "../../entity_types/brand";

// Penguin Random House — real Faire brand (b_q68qsrd57c). Metadata from
// ANALYTICS.CANONICAL.BRANDS. Used by the Penguin Random House advertiser variant.
export const bPenguinRandomHouse: FaireBrandEntity = {
  token: "b_q68qsrd57c",
  type: "brand",
  name: "Penguin Random House",
  description: "Books for everyone — 300+ editorially independent imprints",
  location: "New York, NY",
  isTopShop: true,
  tags: ["books", "paper-novelty", "stationery"],
  meta: {
    source: "snowflake",
    importedAt: "2026-07-20T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
